import type { PdvFlagFilters } from './types';

export const pdvKeys = {
  all: ['pdv'] as const,
  overview: () => [...pdvKeys.all, 'overview'] as const,
  tree: () => [...pdvKeys.all, 'tree'] as const,
  search: (q: string) => [...pdvKeys.all, 'search', q] as const,
  product: (sku: string) => [...pdvKeys.all, 'product', sku] as const,
  /** every flag list, whatever its filters: what a flag action refreshes */
  flags: () => [...pdvKeys.all, 'flags'] as const,
  flagList: (filters: PdvFlagFilters, limit?: number) =>
    [...pdvKeys.flags(), filters, limit ?? 'paged'] as const,
  class: (cls: string) => [...pdvKeys.all, 'class', cls] as const,
  classProducts: (cls: string, q: string) =>
    [...pdvKeys.class(cls), 'products', q] as const,
  preview: (cls: string, name: string, action: string) =>
    [...pdvKeys.class(cls), 'preview', name, action] as const
};
